/**
 * 列表部分自动定高，解决页面数据少时，也撑出滚动条的问题
 * 2018-03-29
 * Bai.Zhiming
 */
"use strict";
angular.module("listAutoHeightModule", []).
directive("listAutoHeight", ["$timeout", "globleParamsSet", function($timeout, globleParamsSet) {
    return {
        restrict: "A",
        scope: false,
        link: function(scope, $elem, $attrs) {
            var referenceElement; //参照元素
            var windowHeight; //窗体高度
            var listTop; //列表的真实高度
            var isMinHeight = $attrs["isMinHeight"] == "false" ? false : true
            try {
                init();
            } catch (e) {
                console.log("列表部分自动定高修补组件，执行失败，请检查代码");
            } finally {}

            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                $timeout(function() {
                    calcuEleHiehgt();
                    watcheReElement();
                    resize();
                }, 500);
            }
            /**
             * [calcuEleHiehgt description] 计算元素高度
             * @return {[type]} [description]
             */
            function calcuEleHiehgt() {
                listTop = $elem.offset().top;
                windowHeight = window.innerHeight;

                var fixHeight = !isNaN($attrs["fixHeight"]) ? Number($attrs["fixHeight"]) : 6;
                var reElemHeightSum = (function() {
                    referenceElement = $attrs["reElement"];
                    referenceElement = referenceElement ? referenceElement.split(",") : "";
                    if (referenceElement === "") return 0;
                    var sum = 0;
                    for (var i in referenceElement) {
                        var $dom = $("." + referenceElement[i]);
                        if ($dom.length == 0) continue;
                        var height = $dom[0].offsetHeight;
                        var marginTopBottom = Number($dom.css("marginTop").replace(/px/g, "")) + Number($dom.css("marginBottom").replace(/px/g, ""));
                        sum += (height + marginTopBottom);
                    }
                    return sum;
                })();
                reElemHeightSum += listTop;
                reElemHeightSum += fixHeight;
                var cssObj = isMinHeight ? {
                    height: "initial",
                    minHeight: windowHeight - reElemHeightSum
                } : {
                    height: windowHeight - reElemHeightSum
                }

                $elem.css(cssObj);

            }
            /**
             * [resize description] 窗口重置变化
             * @return {[type]} [description]
             */
            function resize() {
                window.addEventListener("resize", calcuEleHiehgt);
                scope.$on("$destroy", () => {
                    window.removeEventListener("resize", calcuEleHiehgt);
                });
            }
            /**
             * [watcheReElement description] 监控相
             * 关元素
             



             * @return {[type]} [description]
            \ */
            function watcheReElement() {
                if (referenceElement.length === 0) return;
                for (var i in referenceElement) {
                    var $element = $("." + referenceElement[i]);
                    if ($element.length === 0) continue;
                    globleParamsSet.domObserver($element[0], { subtree: true, attribute: true, attributeOldValue: true }, change);
                }
            }
            /**
             * [change description] 元素变化
             * @return {[type]} [description]
             */
            function change(e) {
                if (e === "initial") return;
                calcuEleHiehgt();
            }
        }
    };
}]);